import { useEffect, useRef, useState } from 'react';
import axios from 'axios';

const failed = value => ['failure', 'failed', 'fail', 'false'].includes(value?.status);

const useHoliday = ({
    mainApi = '/shift_management/api/holiday/setting',
    mainNewYearApi = '/shift_management/api/holiday/new_year',
    scopeKey = '',
    onFinish = () => {},
    onBefore = () => {},
}) => {
    const [data, setData] = useState([]);
    const [newYearData, setNewYearData] = useState(null);
    const requests = useRef({ list: 0, preview: 0 });
    const mounted = useRef(true);
    const scope = JSON.stringify([mainApi, mainNewYearApi, scopeKey]);
    const currentScope = useRef(scope);
    currentScope.current = scope;
    const mutation = useRef(false);
    useEffect(() => {
        mounted.current = true;
        return () => { mounted.current = false; };
    }, []);

    const read = async (kind, params) => {
        const requestId = ++requests.current[kind];
        const active = () => mounted.current && currentScope.current === scope && requests.current[kind] === requestId;
        onBefore({ axiosMode: 'get' });
        try {
            const response = await axios.get(kind === 'preview' ? mainNewYearApi : mainApi, { params });
            const result = response.data;
            if (!result || failed(result) || (kind === 'preview' && !/^[1-9][0-9]{3}$/.test(String(result.year)))) {
                throw Object.assign(new Error('讀取假日資料失敗'), { response: { data: result } });
            }
            if (!active()) return kind === 'preview' ? null : { data: [], total: 0, success: false };
            if (kind === 'preview') setNewYearData(result);
            else setData(Array.isArray(result.data) ? result.data : []);
            onFinish({ axiosMode: 'get', requestType: kind, status: 'success', values: result });
            return result;
        } catch (error) {
            if (active()) {
                if (kind === 'preview') setNewYearData(null);
                else setData([]);
                onFinish({ axiosMode: 'get', requestType: kind, status: 'error', values: error.response?.data });
            }
            return kind === 'preview' ? null : { data: [], total: 0, success: false };
        }
    };

    const write = async (method, values, api) => {
        if (mutation.current) return null;
        mutation.current = true;
        onBefore({ axiosMode: method });
        try {
            const response = await axios({ method, url: api, data: values });
            const result = response.data;
            if (mounted.current && currentScope.current === scope) {
                onFinish({ axiosMode: method, status: result?.status === 'success' ? 'success' : 'error', values: result });
            }
            return result;
        } catch (error) {
            const result = error.response?.data || { status: 'failure', message: '連線失敗，請稍後再試' };
            if (mounted.current && currentScope.current === scope) onFinish({ axiosMode: method, status: 'error', values: result });
            return result;
        } finally {
            mutation.current = false;
        }
    };

    return {
        HolidaySettingDatas: data,
        HolidaySettingNewYearDatas: newYearData,
        getHolidaySettingNewYear: params => read('preview', params),
        getHolidaySettingData: params => read('list', params),
        postHolidaySettingData: values => write('post', values, mainNewYearApi),
        patchHolidaySettingData: values => write('patch', values, mainApi),
        deleteHolidaySettingData: values => write('delete', values, mainApi),
    };
};
export { useHoliday };
